import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export interface AssetImageClasses {
	root: string;
	image: string;
	hideShadow: string;
	progress: string;
}

export const getAssetImageUtilityClass = (slot: string) =>
	generateUtilityClass('AssetImage', slot);

export const assetImageClasses = generateUtilityClasses<
	keyof AssetImageClasses
>('AssetImage', ['root', 'hideShadow', 'image', 'progress']);
export default assetImageClasses;
